export { default } from './Heading';